import { useEffect } from 'react';
import { OperatorDetailsResponse } from 'src/apis/organisation-service/types';
import { useAxios } from 'src/hooks/use-axios';
import { OrganisationDetailsRequest } from 'src/pages/settings/organisation/company-information/use-organisation-details';

export function useOperatorDetails({
  organisationDetails,
}: {
  organisationDetails: OrganisationDetailsRequest;
}) {
  const request = useAxios(
    (axios, signal, url) =>
      axios.request<OperatorDetailsResponse>({
        signal,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (
      organisationDetails.response &&
      (organisationDetails.response.data._links.tsoDetails ||
        organisationDetails.response.data._links.ssoDetails)
    ) {
      const url =
        organisationDetails.response?.data._links.tsoDetails?.href ??
        organisationDetails.response?.data._links.ssoDetails?.href;
      request.execute(url);
    } else {
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organisationDetails.response]);

  return request;
}

export type OperatorDetailsRequest = ReturnType<typeof useOperatorDetails>;
